export { TimepickerConfig } from './timepicker.config';
export { TimepickerComponent } from './timepicker.component';
export { TimepickerModule } from './timepicker.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
